import React, { useState } from 'react';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    name: "Mikhail Rodríguez",
    location: "Caracas, Venezuela",
    rating: 5,
    comment: "Ser parte de RECARX PLUS nos permite llegar a más conductores con respaldo y seguimiento. Sabemos que no estamos solos en la vía.",
    service: "Atención Primaria de Mecánica",
    avatar: "MR",
    date: "Hace 2 días"
  },
  {
    id: 2,
    name: "Elio Colmenarez",
    location: "Barquisimeto, Venezuela",
    rating: 5,
    comment: "Lo que más valoro es que la platafomra respeta al mecánico y al cliente. Aquí todos ganamos confianza y sentimos que somos parte de algo que integra soluciones",
    service: "Mantenimiento preventivo",
    avatar: "",
    date: "Hace 1 semana"
  },
  {
    id: 3,
    name: "Claudio Caolo",
    location: "Caracas, Venezuela",
    rating: 5,
    comment: "RECARX PLUS nos conecta con usuarios que realmente necesitan lo que ofrecemos. Es una red que funciona y nos permite ampliar nuestro el alcance de nuestro servicio.",
    service: "Mantenimiento preventivo",
    avatar: "",
    date: "Hace 3 días"
  },
  {
    id: 4,
    name: "Alexis Machado",
    location: "Artigas, Venezuela",
    rating: 5,
    comment: "Se siente un trabajo de equipo que permite la atención del cliente y su satisfacción.",
    service: "Servicio esspecializado en taller",
    avatar: "h",
    date: "Hace 5 días"
  },
  {
    id: 5,
    name: "Ángel Quintero",
    location: "Baruta, Venezuela",
    rating: 5,
    comment: "Es excelente que los clientes sean referidos por su ubicación geográfica. Nos permite ser más ágiles al atender la necesidad de traslado de un vehículo.",
    service: "Mecánica especializada en taller",
    avatar: "",
    date: "Hace 1 día"
  } 
];

export const Testimonials: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerPage = 3;
  const maxIndex = Math.max(0, testimonials.length - itemsPerPage);

  const nextTestimonials = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prevTestimonials = () => {
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  const visibleTestimonials = testimonials.slice(currentIndex, currentIndex + itemsPerPage);

  // Construye número y mensaje para WhatsApp (usa .env con fallback)
  const phoneEnv = process.env.REACT_APP_WHATSAPP_NUMBER || '';
  const phone = phoneEnv.replace(/\D/g, '') || '584225555500';
  const defaultMsg = process.env.REACT_APP_MESSAGE_REGISTER || 'Hola, me interesa unirme a Recarx Plus. ¿Me pueden ayudar?';
  const joinMessage = `${defaultMsg} Me interesa formar parte de la red como proveedor/aliado.`;
  
  return (
    <section id="testimonios" className="py-12 scroll-mt-12 bg-white dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Lo que dicen nuestros fundadores
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Antes de que los conductores hablen, nuestros aliados ya lo hacen. En RECARX PLUS trabajamos con mecánicos que comparten nuestra visión: atención confiable, transparente y humana. Ellos son los primeros en validar nuestro compromiso con la calidad, la agilidad y el respeto por cada historia de los conductores y sus vehículos.
          </p>
          <p className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
            ¿Quieres formar parte de nuestra red de aliados? <br />
            Conecta con nosotros y únete al cambio en la asistencia automotriz.
          </p>
          <button
            type="button"
            onClick={() => openWhatsApp(phone, joinMessage)}
            className="w-auto px-8 mt-6 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-3 rounded-lg font-medium transition-all duration-300 transform group-hover:scale-105"
            aria-label="Unirse a Recarx Plus vía WhatsApp"
          >
            Únete a Recarx Plus
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-blue-600 dark:text-blue-400 mb-2">0</div>
            <div className="flex justify-center mb-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
              ))}
            </div>
            <div className="text-gray-600 dark:text-gray-300">Calificación promedio</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-blue-600 dark:text-blue-400 mb-2">0+</div>
            <div className="text-gray-600 dark:text-gray-300">Servicios completados</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-blue-600 dark:text-blue-400 mb-2">0+</div>
            <div className="text-gray-600 dark:text-gray-300">Mecánicos verificados</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-blue-600 dark:text-blue-400 mb-2">0%</div>
            <div className="text-gray-600 dark:text-gray-300">Satisfacción</div>
          </div>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {visibleTestimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                className="bg-gray-50 dark:bg-gray-700 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className="flex items-center mb-4">
                  {/*<img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  />*/}
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mr-4">
                    {testimonial.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 dark:text-white">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-gray-300">
                      {testimonial.location}
                    </p>
                  </div>
                </div>

                <div className="flex items-center mb-4">
                  <div className="flex mr-2">
                    {/* [...Array(testimonial.rating)].map((_, i) => (
                      <Star
                        key={i}
                        className="h-4 w-4 text-yellow-400 fill-current"
                      />
                    ))*/}
                  </div>
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    {testimonial.date}
                  </span>
                </div>

                <div className="relative mb-4">
                  <Quote className="absolute -top-2 -left-2 h-8 w-8 text-blue-200 dark:text-blue-800" />
                  <p className="text-gray-700 dark:text-gray-300 pl-6 italic">
                    "{testimonial.comment}"
                  </p>
                </div>

                <div className="bg-blue-50 dark:bg-blue-900/30 rounded-lg px-3 py-2">
                  <span className="text-sm font-medium text-blue-700 dark:text-blue-300">
                    {testimonial.service} {/*Servicio: */}
                  </span>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          {testimonials.length > itemsPerPage && (
            <>
              <button
                onClick={prevTestimonials}
                className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 bg-white dark:bg-gray-700 shadow-lg rounded-full p-3 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
              >
                <ChevronLeft className="h-6 w-6 text-gray-600 dark:text-gray-300" />
              </button>
              <button
                onClick={nextTestimonials}
                className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 bg-white dark:bg-gray-700 shadow-lg rounded-full p-3 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
              >
                <ChevronRight className="h-6 w-6 text-gray-600 dark:text-gray-300" />
              </button>
            </>
          )}
        </div>

        {/* Pagination Dots */}
        {testimonials.length > itemsPerPage && (
          <div className="flex justify-center mt-8 space-x-2">
            {Array.from({ length: maxIndex + 1 }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  index === currentIndex
                    ? 'bg-blue-600'
                    : 'bg-gray-300 dark:bg-gray-600 hover:bg-gray-400 dark:hover:bg-gray-500'
                }`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};